var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-new-credits-panel-confirmation"},[_c('div',{staticClass:"buy-new-credits-panel-confirmation__message"},[_vm._t("icon"),_c('div',{staticClass:"f15 black1"},[_vm._t("text")],2)],2),_c('div',{staticClass:"buy-new-credits-panel-confirmation__buttons"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }